// extracted by mini-css-extract-plugin
export default {"heading":"DeleteFriendsModal_heading__aUQgT"};